export default __webpack_public_path__ + "static/media/friendly-icon.5d6cb6f1.svg";